export default "__VITE_ASSET__tqwNYmfq__"